module.exports = __webpack_public_path__ + "static/media/structFloat2.87f176d8.png";